// extracted by mini-css-extract-plugin
export default {"company-form-section":"CompanyEditor_company-form-section__sYbkp"};